var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHsr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#56428E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04688 4.21875H8.496C8.20125 4.68562 8.02069 5.20144 8.03194 5.76C8.76038 5.76731 9.49106 5.76731 10.2201 5.76C10.2296 5.20481 10.0806 4.67437 9.76163 4.21875H12.2276C12.0578 4.57481 11.7692 4.905 11.7968 5.32294C11.7855 7.19269 11.8007 9.06356 11.7951 10.9333C12.0369 10.9333 12.2816 10.9333 12.5263 10.935C12.7046 10.5806 12.8632 10.2189 12.9898 9.84375C13.7222 9.86231 14.4585 9.82294 15.1875 9.92081C14.4664 10.5429 14.0895 11.4283 13.6198 12.2344C11.7557 12.2383 9.89213 12.2288 8.02631 12.24C7.93856 12.9206 8.35819 13.3892 8.84419 13.7812H5.69588C5.96981 13.4196 6.52163 13.1867 6.46369 12.6562C6.48225 10.8489 6.46369 9.03937 6.46931 7.22981H8.06681V8.34356H10.1863V7.06669H5.76112L4.66144 9C5.02706 9.64519 5.39381 10.2893 5.76281 10.9333H6.30731V12.2344H4.64287C4.03537 11.1544 3.40538 10.0873 2.8125 9V8.99831C3.40706 7.91269 4.03875 6.84562 4.64287 5.76562C5.26387 5.76562 5.88431 5.76562 6.50475 5.76C6.51302 5.21147 6.35303 4.67358 6.04631 4.21875H6.04688ZM8.06738 9.65644V10.9333H10.1863V9.65644H8.06738ZM11.9571 5.76562H13.6164C14.0709 6.49688 14.3837 7.34063 15.0396 7.92563C15.0531 7.96894 15.0772 8.05725 15.0902 8.1C14.3893 8.19225 13.6794 8.12081 12.9729 8.15625C12.8829 7.76644 12.7063 7.40813 12.5106 7.065L11.9571 7.06669V5.76562ZM10.2442 12.3975C10.7342 12.3992 11.2264 12.3975 11.7169 12.3958C11.7056 13.0219 12.1438 13.41 12.5741 13.7812H9.40331C9.81 13.3954 10.2853 13.0292 10.2442 12.3975Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHsr);
export default __webpack_public_path__ + "static/media/hsr.b754829cee13d5fac7bd2b9dbcfa0e02.svg";
export { ForwardRef as ReactComponent };